import { useContext } from 'react';
import { Route, Routes } from 'react-router-dom';

// Third-party packages.
import Helmet from 'react-helmet';

// Context.
import { FilterContext } from '../../../context/FilterContext';

// Views.
import List from './List';
import Detail from './Detail';
import Breadcrumb from "../../../container/breadcrumb";
import AdminTrail from "../../../container/breadcrumb/AdminTrail";
import HeaderActions from "../../../container/header_actions";
import ConditionalRender from "../../../helpers/ConditionalRender";

export default function Snapshots (props: { toggleMenu: Function })
{
	const { filters } = useContext (FilterContext);

	function refresh ()
	{
		// setLoading (true);
	}

	return (
		<div id="content">
			<Helmet>
				<title>Saved Snapshot - Settings - DBmarlin</title>
				<meta name="description" content="Manage your saved Snapshots" />
			</Helmet>

			{/* Heading */}
			<div id="top-header-wrapper" className="row row-cols-lg-3 row-cols-sm-1 row-cols-md-2">
				<Breadcrumb heading="Snapshots">
					{[<AdminTrail key="snapshots-trail" section="Snapshots" sectionPath="/admin/filters"
								  resolveEntityLabel={(id) =>
									  filters.find (filter => filter.id === Number (id))?.name}/>]}
				</Breadcrumb>
				<HeaderActions toggleMenu={props.toggleMenu} refresh={refresh} />
			</div>

			<div className="loader">
				<ConditionalRender if={false}>
					<div className="bar"></div>
				</ConditionalRender>
			</div>

			<div className="row row-cols-1">
				<Routes>
					<Route path="/:actionId" element={<Detail />} />
					<Route path="/:actionId/:filterId" element={<Detail />} />
					<Route path="/" element={<List />} />
				</Routes>
			</div>
		</div>
	);
}
